import { authService } from '@/api/auth.service';
import { clearLanguageSession } from '@/hooks/apply-language-for-session';
import { createToast } from 'mosha-vue-toastify';
import { useMutation } from '@tanstack/vue-query';
import router from '@/router';
import { queryClient } from '@/queries/query-client.ts';
import { ability } from '@/main.ts';

export const useLogout = () => {
  return useMutation({
    mutationFn: () => authService.logout(),
    onSuccess: async () => {
      clearLanguageSession();
      await queryClient.resetQueries({ queryKey: ['token-payload'] });
      await queryClient.resetQueries({ queryKey: ['abilities'] });
      ability.update([]);
      await router.push({ name: 'login' });
    },
    onError: (error) => {
      if (Array.isArray((error as any).response.data.error)) {
        (error as any).response.data.error.forEach((el: any) =>
          createToast(el.message, {
            position: 'top-right',
            type: 'warning',
          }),
        );
      } else {
        createToast((error as any).response.data.message, {
          position: 'top-right',
          type: 'danger',
        });
      }
    },
  });
};
